import React from 'react';

const Manage = () => {
      return (
            <div>
                  <h1>coming soonn </h1>
            </div>
      );
};

export default Manage;